import { useMemo } from 'react';

import { useUserFolders } from '@/shared/features/quiz-folder';
import { useSearchQuizQuery } from '@/shared/quizList/hooks/useSearchQuizQuery';

import {
  buildUserFolderVariables,
  USER_FOLDER_PAGE_SIZE,
} from '../../utils/userFolderVariables';

/**
 * 남의 공개 폴더 전체 목록. 검색어·정렬은 프로필과 같은 `useSearchQuizQuery` 를 읽는다.
 *
 * 목록과 검색바 옆 개수가 이 훅 하나로 같은 조건을 만든다 — 조건이 갈라지면 같은 화면에서 요청이 두 번 나간다.
 */
export const useUserFolderList = (userId: string) => {
  const { searchText, order, period } = useSearchQuizQuery();
  const result = useUserFolders({
    variables: buildUserFolderVariables({
      userId,
      searchText,
      order,
      period,
      limit: USER_FOLDER_PAGE_SIZE,
    }),
  });

  const folders = useMemo(
    () => result.data?.pages.flatMap(page => page.items) ?? [],
    [result.data],
  );

  return {
    ...result,
    folders,
    totalCount: result.data?.pages[0]?.totalCount ?? 0,
  };
};
